"use client";

import { BUSINESS_INFO } from "@/lib/business-info";
import { useTranslations } from "next-intl";
import Section from "../Section";

const addressVars = {
  legalName: BUSINESS_INFO.legalName,
  street: BUSINESS_INFO.street,
  postalCode: BUSINESS_INFO.postalCode,
  city: BUSINESS_INFO.city,
  ceo: BUSINESS_INFO.ceo,
  email: BUSINESS_INFO.email,
};

const Agb = () => {
  const t = useTranslations("agb.sections");

  return (
    <div className="gs--page-column flex flex-col gap-5 py-16">
      {/* Section 1 */}
      <Section title={t("section1.title")}>
        <p>{t("section1.text1", addressVars)}</p>
        <p>{t("section1.text2")}</p>
        <p>{t("section1.text3")}</p>
        <p>{t("section1.text4")}</p>
      </Section>

      {/* Section 2 */}
      <Section title={t("section2.title")}>
        <p>{t("section2.text1")}</p>
        <p>{t("section2.text2")}</p>
      </Section>

      {/* Section 3 */}
      <Section title={t("section3.title")}>
        <p>{t("section3.text1")}</p>
      </Section>

      {/* Section 4 */}
      <Section title={t("section4.title")}>
        <p>{t("section4.text1")}</p>
      </Section>

      {/* Section 5 */}
      <Section title={t("section5.title")}>
        <p>{t("section5.text1")}</p>
      </Section>

      {/* Section 6 */}
      <Section title={t("section6.title")}>
        <p>{t("section6.text1")}</p>
        <p>{t("section6.text2")}</p>
      </Section>

      {/* Section 7 */}
      <Section title={t("section7.title")}>
        <p>{t("section7.text1")}</p>
        <p>{t("section7.text2")}</p>
      </Section>

      {/* Section 8 */}
      <Section title={t("section8.title")}>
        <p>{t("section8.text1")}</p>
        <p>{t("section8.text2")}</p>
        <p>{t("section8.text3")}</p>
      </Section>
      <Section title={t("section9.title")}>
        <p className="font-bold">{t("section9.text1")}</p>
        <p>{t("section9.text2")}</p>
        <p>{t("section9.text3")}</p>
        <p>{t("section9.text4", addressVars)}</p>
        <p>{t("section9.text5")}</p>
        <p className="font-bold">{t("section9.text6")}</p>
        <p>{t("section9.text7")}</p>
        <p className="font-bold">{t("section9.text8")}</p>
        <p className="font-bold">{t("section9.text9")}</p>
        <p>{t("section9.text10")}</p>
        <ul className="list-disc pl-10">
          <li>{t("section9.li1", addressVars)}</li>
          <li>{t("section9.li2")}</li>
          <li>{t("section9.li3")}</li>
          <li>{t("section9.li4")}</li>
          <li>{t("section9.li5")}</li>
          <li>{t("section9.li6")}</li>
          <li>{t("section9.li7")}</li>
        </ul>
        <p>{t("section9.text11")}</p>
      </Section>

      {/* Section 9 */}
      <Section title={t("section10.title")}>
        <p>{t("section10.text1")}</p>
      </Section>

      {/* Section 10 */}
      <Section title={t("section11.title")}>
        <p>{t("section11.text1")}</p>
        <p>{t("section11.text2")}</p>
      </Section>

      {/* Section 11 */}
      <Section title={t("section12.title")}>
        <p>{t("section12.text1")}</p>
        <p>{t("section12.text2")}</p>
        <p>{t("section12.text3")}</p>
        <p>{t("section12.text4")}</p>
        <p>{t("section12.text5")}</p>
      </Section>

      <p className="text-ring">{t("date")}</p>
    </div>
  );
};

export default Agb;
